export default {
  sections: {
    address: 'Morada da empresa',
    address_help: 'Introduza a morada onde a sua empresa está registada. É impressa nas suas faturas.',
  },
  form: {
    legal_form: {
      label: 'Tipo de empresa',
      help: 'Uma UG (haftungsbeschränkt) é aqui uma GmbH, uma e.K. é um empresário em nome individual. Para uma OHG ou KG, contacte o suporte.',
      options: {
        sole_trader: 'Empresário em nome individual',
        gbr: 'GbR',
        gmbh: 'GmbH / UG',
      },
    },
    legal_name: {
      label: 'Nome comercial registado',
      placeholder: 'Introduza o nome comercial registado',
      sole_trader_help: 'Deixe em branco se negociar em seu próprio nome',
    },
  },
  buttons: {
    next: 'Seguinte',
  },
};
